import { createContext } from "react";

const Configurationcontext = createContext();

export default Configurationcontext;
